<template>
  <main class="main">
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-0 mb-lg-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/library">Biblioteca</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <LoadedComponent :loading="loading" />

    <div class="page-content" v-if="!loading">
      <div class="container">
        <div class="mb-2">
          <AlertComponent :message="successMessage" :alert-type="'success'" />
        </div>

        <div class="row">
          <FilterComponent :activities="activities" @setActivities="setActivities" :patologies="patologies"
            :categoryMedicals="categoryMedicals" :anatomicalDistricts="anatomicalDistricts"
            v-on:update:filteredPatologies="updatePatologies"
            v-on:update:filteredCategoryMedicals="updateCategoryMedicals"
            v-on:update:filteredAnatomicalDistricts="updateAnatomicalDistricts" category="2"
            :permission="permission.create_biblioteca"></FilterComponent>

          <div class="col-lg-9">
            <div class="row" v-if="activities.length > 0">
              <div class="entry-item lifestyle shopping col-lg-4" v-for="library in activities" :key="library.id">
                <article class="entry entry-grid text-center">
                  <figure class="entry-media">
                    <router-link :to="getRoute(library.slug)">
                      <div v-if="library.cover != null">
                        <div v-if="
                          library.cover.type_file == 'jpg' ||
                          library.cover.type_file == 'png' ||
                          library.cover.type_file == 'jpeg'
                        ">
                          <img :src="library.cover.path" alt="Copertina biblioteca" class="img-fluid" />
                        </div>
                        <div v-else-if="library.cover.type_file == 'pdf'">
                          <div class="embed-responsive embed-responsive-16by9 center-block">
                            <iframe :src="library.cover.path">Contenuto</iframe>
                            *
                          </div>
                        </div>
                        <div v-else>
                          <img
                            src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg"
                            alt="image desc" />
                        </div>
                      </div>

                      <div v-else>
                        <img
                          src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg"
                          alt="image desc" />
                      </div>
                    </router-link>
                  </figure>

                  <div class="entry-body">
                    <div class="entry-meta">
                      <span class="entry-author">
                        by <a href="#">{{ library.full_name }} </a>
                      </span>
                      <span class="meta-separator">|</span>
                      <a href="#">{{ library.created_at }}</a>
                    </div>
                    <!-- End .entry-meta -->

                    <h2 class="entry-title">
                      <router-link :to="'/library/show/' + library.slug">{{
                        library.name
                        }}</router-link>
                    </h2>
                    <!-- End .entry-title -->
                  </div>
                  <!-- End .entry-body -->
                </article>
              </div>
            </div>

            <div class="row" v-else>
              <p>Nessun risultato</p>
            </div>

            <nav aria-label="Page navigation"></nav>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import { useAuth } from "@/stores/auth.js";
import AlertComponent from "@/components/AlertComponent.vue";
import LoadedComponent from "@/components/LoadedComponent.vue";
import FilterComponent from "@/components/FilterComponent.vue";
export default {
  name: "LibraryPage",
  components: { AlertComponent, LoadedComponent, FilterComponent },
  props: {},
  data() {
    return {
      libraries: [],
      permission: {},
      successMessage: "",
      loading: true,
      errors: [],
      activities: [],
      originalActivities: [],
      patologies: [],
      categoryMedicals: [],
      anatomicalDistricts: [],
      filteredPatologies: [],
      filteredCategoryMedicals: [],
      filteredAnatomicalDistricts: [],
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("successMessageLibrary");

    localStorage.removeItem("successMessageLibrary");
    this.getLibraries();
    this.loadPermission();
    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
  created() { },
  methods: {
    async getLibraries() {
      await httpauth
        .get("/libraries")
        .then((response) => {
          this.activities = response.data.data;
          this.originalActivities = this.activities;
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    getRoute(slug) {
      if (this.permission.show_biblioteca)
      {
        return "/library/show/" + slug;
      }
      return "#";
    },
    async loadPermission() {
      await httpservices
        .checkPermission(1, "biblioteca", "create_biblioteca")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setActivities(value) {
      this.activities = value;
    },
    updatePatologies(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.patology_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.patologies);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.patology_id)
        );
      }
    },
    updateCategoryMedicals(selectedCategories) {
      console.log(selectedCategories);
    },
    updateAnatomicalDistricts(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.anatomical_district_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.anatomicalDistricts);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.anatomical_district_id)
        );
      }
    },
    mappingOriginalArray(originalArray) {
      return originalArray.map((item) => item.id);
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedicals = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistricts = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>